import React, { useState } from "react";
import { Card, Col, Row, Accordion, AccordionItem } from "reactstrap";
import AccordionSessionHeader from "./Accordion/AccordionSessionHeader";
import useAssessmentTexts from "../../data/hooks/useAssessmentTexts";
import LatestSessionStats from "./SessionStats/LatestSessionStats";
import AccordionSessionBody from "./Accordion/AccordionSessionBody";
import ErrorDisplay from "../Error/ErrorDisplay";
import ClipLoader from "../Loading/ClipLoader";

const LatestSession = ({ session, miscueList, getLevel }) => {
  const [isOpen, setIsOpen] = useState("0");
  const handleToggle = (id) => setIsOpen(isOpen === id ? "" : id);

  const keyItem = "0";
  const assessmentTextId = session.assessmentText;
  const {
    isAssessmentTextsLoading,
    assessmentTextsError,
    assessmentTextsData,
  } = useAssessmentTexts(assessmentTextId);

  if (assessmentTextsError) {
    return (
      <ErrorDisplay
        userMessage={"Error while fetching sections"}
        errorMessage={assessmentTextsError}
      />
    );
  }

  if (isAssessmentTextsLoading) {
    return <ClipLoader />;
  }

  const sessionDate = session?.createdAt;
  const textLevel = getLevel(assessmentTextsData?.level);

  return (
    <div className="accordion-sessions-list-items">
      <Accordion key={keyItem} open={isOpen} toggle={handleToggle}>
        <AccordionItem className="session-item-block-area">
          <Row key={keyItem}>
            <Col md={12}>
              <Card>
                <AccordionSessionHeader date={sessionDate} targetId={keyItem} />

                <AccordionSessionBody
                  session={session}
                  assessmentText={assessmentTextsData}
                  keyItem={keyItem}
                  miscueList={miscueList}
                >
                  <LatestSessionStats session={session} textLevel={textLevel} />
                </AccordionSessionBody>
              </Card>
            </Col>
          </Row>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default LatestSession;
